export default "__VITE_ASSET__Bza46kwR__"